import { Feature } from "ol";
import Style from "ol/style/Style";

export default abstract class BaseFeature {

    create(): Feature {
        if (this.isValid()) {
            const feature = this.getFeature()
            feature.setStyle(this.getStyle())
            return feature
        }
        return new Feature()
    }

    abstract getFeature(): Feature
    abstract getStyle(): Style
    abstract isValid(): boolean
}